(function ($) {

    var menu = $(".mobile-menu");

    $(".navbar__hamburger").on("click", function (e) {

        e.preventDefault();

        menu.addClass("is-active");

    });

    var sticky_nav = $(".sticky-navbar__outer");

    var hero_space = $(".hero-space__outer");

    $("body").on("scroll resize", function () {

        var self = $(this);

        var scroll = self.scrollTop();

        var offset = typeof hero_space !== "undefined" ? hero_space.height() : 680;

        sticky_nav[scroll > offset ? "addClass" : "removeClass"]("is-active");

    });

    objectFitImages("img", {"watchMQ": true});

})(jQuery);

(function ($) {

    var html = $("html");

    if (bowser.name === "Microsoft Edge") {
        html.addClass("is-edge");
    } else if (bowser.name === "Safari") {
        html.addClass("is-safari");
    } else if (bowser.name === "Firefox") {
        html.addClass("is-firefox");
    }

})(jQuery);

if (!String.prototype.includes) {

    Object.defineProperty(String.prototype, "includes", {

        value: function (search, start) {

            if (typeof start !== "number") {
                start = 0
            }

            if (start + search.length > this.length) {
                return false;
            } else {
                return this.indexOf(search, start) !== -1;
            }

        }

    });

}

if (!Array.prototype.includes) {

    Object.defineProperty(Array.prototype, "includes", {

        value: function (valueToFind, fromIndex) {

            if (this == null) {
                throw new TypeError("\"this\" is null or not defined");
            }

            var o = Object(this);

            var len = o.length >>> 0;

            if (len === 0) {
                return false;
            }

            var n = fromIndex | 0;

            var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

            function sameValueZero(x, y) {
                return x === y || (typeof x === "number" && typeof y === "number" && isNaN(x) && isNaN(y));
            }

            while (k < len) {

                if (sameValueZero(o[k], valueToFind)) {
                    return true;
                }

                k++;

            }

            return false;
        }

    });

}


(function ($) {

    $.fn.in_viewport = function () {

        var top = $(this).offset().top;
        var bottom = top + $(this).outerHeight();

        var viewport_top = $(window).scrollTop();
        var viewport_bottom = viewport_top + $(window).height();

        return bottom > viewport_top && top < viewport_bottom;

    };

})(jQuery);

(function ($) {

    $(".hero-slider").each(function () {

        var self = $(this);

        var controls = self.find(".hero-slider__controls__item");

        var slides = self.find(".hero-slider__item");

        var interval = null;

        function change_slide(next) {

            var current = slides.filter(".is-active");

            if (!next || next.length === 0) {
                next = current.next();
            }

            if (!next || next.length === 0) {

                next = slides.eq(0);

                clear_controls();

            }

            var id = next.data("id");

            activate_control(id);

            current.removeClass("is-active");
            next.addClass("is-active");

        }

        function clear_controls() {
            controls.removeClass("is-active").removeClass("force-active");
        }

        function activate_control(id) {

            setTimeout(function () {

                controls.filter(function () {
                    return $(this).data("id") === id;
                }).addClass("is-active");

            }, 50);

        }

        function slide_for_control(control) {

            var id = control.data("id");

            return slides.filter(function () {
                return $(this).data("id") === id;
            });

        }

        function initialize() {

            var current = slides.filter(".is-active");

            var id = current.data("id");

            clear_controls();
            activate_control(id);

            interval = setInterval(change_slide, 4050);

            controls.on("click", function () {

                var self = $(this);

                clearInterval(interval);
                clear_controls();

                self.prevAll().addClass("force-active");
                change_slide(slide_for_control(self));

                interval = setInterval(change_slide, 4050);

            });

        }

        initialize();

    });

})(jQuery);

(function ($) {

    var videos = $(".hero-video");

    function update_videos(supported) {

        videos.each(function () {

            var self = $(this);
            self.find(supported ? "video" : "img").removeClass("hidden");

        });

    }

    if (videos.length > 0) {

        if (Modernizr.video) {
            /*  document.addEventListener("WeixinJSBridgeReady", function () {
                  var videos = $(".hero-video");
                  videos.find("video").each(function(v){
                      var v = $(this);
                      v = v[0];
                      v.autoplay=false
                      v.controls = true
                      //v.play();
                      update_videos(false);

                  })
              }, false)*/


            var video = document.createElement("video");

            video.autoplay = true;
            video.muted = true;
            video.setAttribute("playsinline", "");
            video.src = "data:video/mp4;base64,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";
            video.style.display = "none";
            video.playing = false;
            video.play();

            video.onplay = function () {
                video.playing = true;
            };

            video.oncanplay = function () {
                update_videos(video.playing);
            };


        } else {
            update_videos(false);
        }

    }

})(jQuery);

(function ($) {

    var side_menus = $(".menu-side__outer");

    var mobile_menu = $(".mobile-menu-popup__outer");

    $(".menu-side__bar__container").each(function () {

        var self = $(this);

        var items = self.find(".menu-side__bar__item");

        function open_item(item) {

            var active = item.hasClass("is-active");

            items.not(item).removeClass("is-active").find(".menu-side__bar__item__body").stop().slideUp();

            var body = item.find(".menu-side__bar__item__body");

            item[active ? "removeClass" : "addClass"]("is-active");
            body[active ? "slideUp" : "slideDown"]();

        }

        self.find("div.menu-side__bar__item .menu-side__bar__item__header").on("click", function (e) {

            e.preventDefault();

            var self = $(this);

            var item = self.parents(".menu-side__bar__item");

            open_item(item);

        });

    });

    side_menus.on("click", function (e) {

        var target = $(e.target);

        if (target.parents(".menu-side__bar").length > 0 || target.hasClass("menu-side__bar")) {
            return;
        }

        side_menus.fadeOut().removeClass("is-active");

    });

    side_menus.find(".menu-side__arrow").on("click", function (e) {

        e.preventDefault();

        side_menus.fadeOut().removeClass("is-active");

    });

    $(document).on("keydown", function (e) {

        e = e || window.event;

        if (e.keyCode === 27) {
            side_menus.fadeOut().removeClass("is-active");
        }

    });

    $(".js--trigger-side-menu").on("click", function (e) {

        e.preventDefault();

        side_menus.fadeIn().addClass("is-active");

        $(".sub-menu__item__language .icon.icon--close").addClass("hidden");
        $(".sub-menu__item__language .icon.icon--language").removeClass("hidden");

        $(".mobile-menu__language .icon.icon--close").addClass("hidden");
        $(".mobile-menu__language .icon.icon--language").removeClass("hidden");

    });

    $(".js--trigger-mobile-popup-menu").on("click", function (e) {

        e.preventDefault();

        var self = $(this);

        if (self.hasClass("hamburger")) {
            self.toggleClass("is-active");
        }

        if (mobile_menu.hasClass("is-active")) {
            mobile_menu.removeClass("is-active");
        } else {
            mobile_menu.addClass("is-active");
        }

        $(".mobile-language__outer").removeClass("is-active");

        $(".sub-menu__item__language .icon.icon--close").addClass("hidden");
        $(".sub-menu__item__language .icon.icon--language").removeClass("hidden");

        $(".mobile-menu__language .icon.icon--close").addClass("hidden");
        $(".mobile-menu__language .icon.icon--language").removeClass("hidden");

    });

    $(".sub-menu__item__search i.icon.icon--search").on("click", function (e) {

        e.preventDefault();

        var field = $(".sub-menu__item__search-field");

        field.addClass("is-active");
        field.find("input")[0].focus();

    });

    $(".sub-menu__item__search-field .icon.icon--close").on("click", function (e) {

        e.preventDefault();

        var self = $(this);

        var parent = self.parent();

        parent.removeClass("is-active");

    });

    $(".sub-menu__item__language").on("click", function (e) {

        e.preventDefault();

        $(".sub-menu__item__pick-language").animate({"width": "toggle"});

    });

    $(".mobile-secondary-menu").each(function () {

        var menu = $(this);

        var current = menu.find(".mobile-secondary-menu__current");

        var dropdown = menu.find(".mobile-secondary-menu__dropdown");

        current.on("click", function (e) {

            e.preventDefault();

            menu.toggleClass("is-active");

            if (menu.hasClass("is-active")) {
                dropdown.show();
                // dropdown.stop().slideDown();
            } else {
                dropdown.hide();
                // dropdown.stop().slideUp();
            }

        });

    });

    $(".mobile-menu__language").on("click", function (e) {

        e.preventDefault();

        var language = $(".mobile-language__outer");

        language.toggleClass("is-active");
        mobile_menu.removeClass("is-active");

        $(".js--trigger-mobile-popup-menu.hamburger").removeClass("is-active");

        if (language.hasClass("is-active")) {

            $(".sub-menu__item__language .icon.icon--close").removeClass("hidden");
            $(".sub-menu__item__language .icon.icon--language").addClass("hidden");

            $(".mobile-menu__language .icon.icon--close").removeClass("hidden");
            $(".mobile-menu__language .icon.icon--language").addClass("hidden");

        } else {

            $(".sub-menu__item__language .icon.icon--close").addClass("hidden");
            $(".sub-menu__item__language .icon.icon--language").removeClass("hidden");

            $(".mobile-menu__language .icon.icon--close").addClass("hidden");
            $(".mobile-menu__language .icon.icon--language").removeClass("hidden");

        }

    });

    mobile_menu.each(function () {

        var menu = $(this);

        var results = menu.find(".mobile-menu__search-results");

        var container = menu.find(".menu-side__bar__container");

        var handle = function () {

            var self = $(this);

            var value = self.val();

            if (value.length >= 3) {
                results.removeClass("hidden");
                container.addClass("hidden");
            } else {
                results.addClass("hidden");
                container.removeClass("hidden");
            }

        };

        var input = menu.find(".mobile-menu-popup__search input");

        menu.find(".mobile-menu-popup__search").on("reset", handle);
        input.on("keyup change reset", handle);

        input.on("focus", function () {

            var self = $(this);

            var value = self.val();

            if (value.length >= 3) {
                results.removeClass("hidden");
                container.addClass("hidden");
            }

        });

        results.find("li").on("click", function (e) {

            e.preventDefault();

            var self = $(this);

            input.val(self.text());

            results.addClass("hidden");
            container.removeClass("hidden");

        });

    });

})(jQuery);

(function ($) {

    $(".mobile-footer").each(function () {

        var self = $(this);

        var accordion = self.find(".mobile-footer__accordion");

        var items = accordion.find(".mobile-footer__accordion__item");

        function toggle_item(item) {

            var active = item.hasClass("is-active");

            var body = item.find(".mobile-footer__accordion__item__body");

            items.not(item).removeClass("is-active").find(".mobile-footer__accordion__item__body").stop().slideUp();

            body[active ? "slideUp" : "slideDown"]();
            item[active ? "removeClass" : "addClass"]("is-active");

        }

        accordion.find("div.mobile-footer__accordion__item .mobile-footer__accordion__item__header").on("click", function (e) {

            e.preventDefault();

            var self = $(this);

            var item = self.parents(".mobile-footer__accordion__item");

            toggle_item(item);

        });

    });

})(jQuery);

(function ($) {

    var cards = $(".card, .text-card, .product-cards__item");

    var queue = [];

    var interval = null;

    function handle_cards() {

        cards.filter(function () {
            return $(this).css("opacity") == 0;
        }).each(function () {

            var self = this;

            if ($(self).in_viewport() && !queue.includes(self)) {
                queue.push(self);
            }

        });

    }

    function initialize() {

        $(window).on("resize scroll", handle_cards);
        $("body").on("scroll", handle_cards);

        handle_cards();

        interval = setInterval(function () {

            var card = queue.shift();

            if (typeof card !== "undefined") {
                $(card).animate({"opacity": 1});
            }

        }, 200);

    }

    initialize();

})(jQuery);

(function ($) {

    $(".advanced-battery__specification").each(function () {

        var self = $(this);

        var items = self.find(".advanced-battery__specification__item");

        items.each(function () {

            var item = $(this);

            var popup = item.find(".advanced-battery__specification__item__popup");

            item.find("header").on("click", function (e) {

                e.preventDefault();

                item.toggleClass("is-active");

                if (item.hasClass("is-active")) {
                    popup.fadeIn();
                } else {
                    popup.fadeOut();
                }

            });

        });

    });

})(jQuery);

(function ($) {

    $(".mobile-carousel").slick({
        "arrows": false,
        "infinite": true,
        "swipeToSlide": true,
        "variableWidth": true
    });

    $(".desktop-carousel").each(function () {

        $(this).slick({
            "arrows": true,
            "infinite": true,
            "swipeToSlide": true,
            "prevArrow": "<button type=\"button\" class=\"slick-prev slick-arrow\"></button>",
            "nextArrow": "<button type=\"button\" class=\"slick-next slick-arrow\"></button>",
            "slidesToShow": 1,
            "variableWidth": false
        });

    });

    $(".about__carousel").slick({
        "arrows": false,
        "infinite": true,
        "swipeToSlide": true,
        "variableWidth": true
    });

})(jQuery);

(function ($) {

    var side_pages = $(".side-page__outer");

    var background = $(".side-page-background__outer");

    var body = $("body");

    function find_side_page(id) {

        return side_pages.filter(function () {
            return $(this).data("id") === id;
        });

    }

    function open_side_page(id) {

        var side_page = find_side_page(id);

        if (typeof side_page === "undefined" || side_page == null) {

            console.error("The side page for id '" + id + "' couldn't be found.");

            return;

        }

        var container = side_page.find(".side-page");

        if (typeof side_page !== "undefined") {

            side_page.addClass("is-active");
            background.stop().fadeIn();
            container.stop().animate({"left": 0, "top": 0});
            body.css("overflow", "hidden");

        }

    }

    $(".js--trigger-side-page").on("click", function (e) {

        e.preventDefault();

        var self = $(this);

        var id = self.data("id");

        open_side_page(id);

    });

    $(".side-page__return").on("click", function (e) {

        e.preventDefault();

        var self = $(this);

        var side_page = self.parents(".side-page__outer");

        var container = side_page.find(".side-page");

        var properties = {"top": "100%"};

        if (window.innerWidth >= 992) {
            properties = {"left": "100%"};
        }

        container.stop().animate(properties);

        background.stop().fadeOut(function () {
            side_page.removeClass("is-active");
        });

        body.attr("style", "");

    });

})(jQuery);

(function ($) {

    var video_triggers = $(".js--trigger-video");

    var page_container = $(".page-container");

    var popup_cache = {};

    video_triggers.each(function () {

        var self = $(this);

        var popup = $("<div class=\"video-popup__outer\"><div class=\"video-popup\"><div class=\"row\"><div class=\"col-xs-12 col-md-2\"></div><div class=\"col-xs-12 col-md-8\"><button class=\"hamburger hamburger--spin js--trigger-video-popup is-active\" type=\"button\"><span class=\"hamburger-box\"></span><span class=\"hamburger-inner\"> </span></button><div class=\"video-popup__container\"></div></div><div class=\"col-xs-12 col-md-2\"></div></div></div></div>");

        var player = null;

        var instance = null;

        var id = null;

        if (this.hasAttribute("data-youtube")) {
            player = "<div class=\"plyr__video-embed video-player\">\n" +
                "<iframe src=\"https://www.youtube.com/embed/" + (id = self.data("youtube")) + "?origin=https://plyr.io&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1\" allowfullscreen allowtransparency allow=\"autoplay\"></iframe>\n" +
                "</div>";
        } else if (this.hasAttribute("data-vimeo")) {
            player = "<div class=\"video-player\" data-plyr-provider=\"vimeo\" data-plyr-embed-id=\"" + (id = self.data("vimeo")) + "\"></div>";
        } else if (this.hasAttribute("data-direct")) {
            player = "<div class=\"video-player\"></div>";
            id = self.data("direct");
        }

        if (popup_cache.hasOwnProperty(id)) {

            self.on("click", function (e) {

                e.preventDefault();

                var popup = page_container.find(".video-player[data-plyr-embed-i]").filter(function () {
                    return $(this).data("plyr-embed-i") === popup_cache[id];
                }).parents(".video-popup__outer");

                popup.fadeIn(function () {
                    instance.stop();
                    instance.play();
                });

            });

        } else if (player != null) {

            popup.find(".video-popup__container").append(player = $(player));
            page_container.append(popup);

            var options = {
                "captions": {"active": false, "language": "auto", "update": false}
            };

            if (this.hasAttribute("data-direct")) {
                options["blankVideo"] = self.data("direct");
            }

            instance = new Plyr(player);

            self.on("click", function (e) {

                e.preventDefault();

                popup.fadeIn(function () {
                    instance.stop();
                    instance.play();
                });

            });

            popup.on("click", function (e) {

                var target = $(e.target);

                if (target.hasClass("video-popup__container") || target.parents(".video-popup__container").length > 0) {
                    return false;
                }

                popup.fadeOut(function () {
                    instance.stop();
                });

            });


            $(document).on("keydown", function (e) {

                e = e || window.event;

                if (e.keyCode === 27) {

                    popup.fadeOut(function () {
                        instance.stop();
                    });

                }

            });

        } else {
            console.error("An error occurred while initializing the video player.");
        }

    });

})(jQuery);

(function ($) {

    var fields = $(".input-field");

    var forms = $("form");

    fields.each(function () {

        var field = $(this);

        var input = field.find("input");

        input.on("focus", function () {

            field.addClass("is-active");

        });

        input.on("blur", function () {

            var value = input.val();

            if (value.length <= 0) {
                field.removeClass("is-active").removeClass("is-error").removeClass("is-valid");
            }

        });

        input.on("change", function () {

            if (this.checkValidity()) {
                field.addClass("is-valid");
                field.removeClass("is-error");
            } else {
                field.removeClass("is-valid");
                field.addClass("is-error");
            }

        });

    });

    forms.each(function () {

        var form = $(this);

        form.on("submit", function (e) {

            var has_error = false;

            var fields = form.find(".input-field");

            fields.each(function () {

                var self = $(this);

                var input = self.find("input");

                if (input[0].hasAttribute("data-required")) {

                    var value = input.val();

                    if (value.length <= 0) {
                        self.addClass("is-error");
                    }

                    if (self.hasClass("is-error")) {
                        has_error = true;
                    }

                }

            });

            if (has_error) {
                e.preventDefault();
            }

        });

    });

})(jQuery);

(function ($) {

    var specifications = $(".specifications");

    specifications.each(function () {

        var specification = $(this);

        var buttons = specification.find(".specifications__tabs__button");

        var items = specification.find(".specifications__tabs__item");

        buttons.on("click", function (e) {

            e.preventDefault();

            var self = $(this);

            var id = self.data("id");

            buttons.removeClass("is-active");
            self.addClass("is-active");

            items.removeClass("is-active");
            items.filter(function () {
                return $(this).data("id") === id;
            }).addClass("is-active");

        });

    });

})(jQuery);

(function ($) {

    var milestones = $(".milestones__outer");

    if (milestones.length > 0) {

        var body = $("body");

        var lock_element = $("html, body");

        var scroll_hook = body;

        var scroll_element = body[0];

        var last_scroll_top = 0;

        function lock_scroll() {
            lock_element.css("overflow", "hidden");
        }

        function unlock_scroll() {
            lock_element.attr("style", "");
        }

        if (bowser.name === "Safari" || bowser.name === "Firefox" || bowser.name === "Microsoft Edge" || bowser.name === "Internet Explorer") {
            scroll_hook = $(window);
            scroll_element = document.documentElement;
        }

        $(document).on("mousewheel wheel", function (e) {

            e = e || window.event;

            if (window.innerWidth >= 992) {

                var delta = bowser.name === "Firefox" ? (-e.originalEvent.deltaY / 3) : (e.originalEvent.wheelDeltaY / (bowser.name === "Safari" ? 3 : 5));

                var max_amount = bowser.name === "Safari" || bowser.name === "Firefox" || bowser.name === "Microsoft Edge" || bowser.name === "Internet Explorer" ? 30 : 50;

                if (Math.abs(delta) >= max_amount) {
                    delta = delta < 0 ? -max_amount : max_amount;
                }

                var slider = milestones.find(".milestones__slider");

                if (milestones.hasClass("milestones__outer--down")) {

                    slider.scrollLeft(slider.scrollLeft() - delta);

                    if ((slider.scrollLeft() <= 0 && delta > 0) || slider.scrollLeft() >= (slider[0].scrollWidth - slider[0].clientWidth)) {

                        milestones.addClass("milestones__outer--finished");
                        milestones.removeClass("milestones__outer--down");
                        unlock_scroll();

                    }

                } else if (milestones.hasClass("milestones__outer--up")) {

                    slider.scrollLeft(slider.scrollLeft() - delta);

                    if ((slider.scrollLeft() <= 0 && delta > 0) || slider.scrollLeft() >= (slider[0].scrollWidth - slider[0].clientWidth)) {

                        milestones.removeClass("milestones__outer--down");
                        milestones.removeClass("milestones__outer--up");
                        unlock_scroll();

                    }

                }

            }

        });

        scroll_hook.on("scroll", function () {

            var self = $(this);

            if (window.innerWidth >= 992) {

                var scroll_top = self.scrollTop();

                var position = milestones.position();

                var direction = last_scroll_top < scroll_top ? "down" : "up";

                var scroll_height = scroll_element.scrollHeight - scroll_element.clientHeight;

                last_scroll_top = scroll_top;

                if (direction === "down") {

                    if (scroll_top >= position.top && scroll_top <= Math.ceil(position.top + milestones.height()) && !milestones.hasClass("milestones__outer--finished") && !milestones.hasClass("milestones__outer--up")) {

                        scroll_hook.scrollTop(position.top);
                        milestones.addClass("milestones__outer--down");
                        milestones.removeClass("milestones__outer--up");
                        milestones.removeClass("milestones__outer--finished");
                        lock_scroll();

                    }

                }

                if (direction === "up") {

                    var up_height = (scroll_height - (scroll_element.scrollHeight - position.top));

                    if (scroll_top >= up_height && scroll_top <= Math.ceil(up_height + milestones.height()) && milestones.hasClass("milestones__outer--finished")) {

                        scroll_hook.scrollTop(scroll_height - (scroll_element.scrollHeight - position.top - milestones.height()));
                        milestones.removeClass("milestones__outer--finished");
                        milestones.removeClass("milestones__outer--down");
                        milestones.addClass("milestones__outer--up");
                        lock_scroll();

                    }

                }

            }


        });

    }

})(jQuery);

(function ($) {

    var triggers = $(".js--trigger-image-popup");

    var body = $("body");

    triggers.on("click", function (e) {

        e.preventDefault();

        var self = $(this);

        var images = [];

        var group_images = $(".js--trigger-image-popup").filter(function () {
            return !$(this).is(":hidden");
        });

        var index = 0;

        group_images.each(function (i) {

            var group_image = $(this);

            var image = group_image.find("img");

            if (typeof image === "undefined") {
                image = group_image;
            }

            images.push(image.prop("src"));

            if (group_image[0] === self[0]) {
                index = i;
            }

        });

        body.prepend($("<div class=\"image-popup__outer\">" +
            "<div class=\"image-popup\">" +
            "	<div class=\"row\">" +
            "		<div class=\"col-xs-12 col-md-1\"></div>" +
            "		<div class=\"col-xs-12 col-md-10\">" +
            "			<div class=\"image-popup__close\">" +
            "				<button class=\"hamburger hamburger--spin is-active\" type=\"button\">" +
            "					<span class=\"hamburger-box\"></span>" +
            "					<span class=\"hamburger-inner\"></span>" +
            "				</button>" +
            "			</div>" +
            "			<div class=\"image-popup__carousel\"></div>" +
            "		</div>" +
            "	</div>" +
            "</div>" +
            "</div>"));

        var popup = $(".image-popup__outer");

        var close = $(".image-popup__close");

        var carousel = popup.find(".image-popup__carousel");

        $(document).on("keydown", function (e) {

            e = e || window.event;

            if (e.keyCode === 27) {
                popup.remove();
                body.attr("style", "");
            }

        });

        popup.on("click", function (e) {

            var target = $(e.target);

            if (target.parents(".image-popup__carousel, .image-popup__close, .image-popup .slick-arrow").length > 0 || target.hasClass("image-popup__carousel") || target.hasClass("image-popup__close") || target.hasClass("slick-arrow")) {
                return true;
            }

            popup.remove();
            body.attr("style", "");

        });

        close.on("click", function (e) {

            e.preventDefault();

            popup.remove();
            body.attr("style", "");

        });

        for (var i = 0; i < images.length; i++) {

            carousel.append($("<div>" +
                "<img src=\"" + images[i] + "\" alt=\"\" />" +
                "</div>"));

        }

        carousel.slick({
            "arrows": true,
            "infinite": true,
            "swipeToSlide": true,
            "prevArrow": "<button type=\"button\" class=\"slick-prev slick-arrow\"></button>",
            "nextArrow": "<button type=\"button\" class=\"slick-next slick-arrow\"></button>",
            "adaptiveHeight": true,
            "dots": false,
            "responsive": [
                {
                    "breakpoint": 768,
                    "settings": {
                        "arrows": false,
                        "infinite": true,
                        "dots": true,
                    }
                }
            ],
            "initialSlide": index,
            "centerMode": true,
            "variableWidth": false,
            "slidesToShow": 1,
            "slidesToScroll": 1
        });

        carousel.on("init beforeChange afterChange", update_dots);

        function update_dots() {

            var dots = carousel.find(".slick-dots");

            dots.find("li").removeClass("slick-active-medium").removeClass("slick-active-large");

            var active = dots.find("li.slick-active");

            active.prev().addClass("slick-active-medium");
            active.next().addClass("slick-active-medium");
            active.addClass("slick-active-large");

        }

        setTimeout(function () {
            update_dots();
        }, 5);

        body.css("overflow", "hidden");

    });

})(jQuery);

(function ($) {

    var dots = $(".globe__dot");

    var map = $(".industrial-parks__map");

    var location = $(".industrial-parks__map__location");

    var location_dot = location.find("div");

    var location_title = location.find("span");

    var current_dot = null;

    dots.on("click", function (e) {

        e.preventDefault();

        var self = $(this);

        if (current_dot !== self) {
            current_dot = self;
        } else {
            current_dot = null;
        }

        update_location();

    });

    location_dot.on("click", function (e) {

        e.preventDefault();

        current_dot = null;

        update_location();

    });

    function update_location() {

        if (current_dot !== null && window.innerWidth >= 992) {

            var position_globe = map[0].getBoundingClientRect();

            var position_dot = current_dot[0].getBoundingClientRect();

            location_dot
                .css("width", Math.floor(position_dot.width))
                .css("height", Math.floor(position_dot.height));

            location
                .addClass("is-active")
                .css("top", (position_dot.top - position_globe.top))
                .css("left", (position_dot.left - position_globe.left));

            location_title.text(current_dot.data("title"));

        } else {

            location.removeClass("is-active");

        }

    }

    $(window).on("resize", function () {

        update_location();

    });

})(jQuery);

(function ($) {

    var counters = $(".js--count-up");

    var queue = [];

    var interval = null;

    function handle_counters() {

        counters.each(function () {

            var self = this;

            if ($(self).in_viewport() && !queue.includes(self) && !self.hasAttribute("data-animating")) {
                queue.push(self);
            }

        });

    }

    function initialize() {

        $(window).on("resize scroll", handle_counters);
        $("body").on("scroll", handle_counters);

        handle_counters();

        interval = setInterval(function () {

            for (var i = queue.length; i--;) {

                var current = $(queue[i]);

                current.attr("data-animating", "true");

                (function ($this, count_to) {

                    $({"count_num": $this.text()}).animate(
                        {"count_num": count_to},
                        {
                            "duration": 2000,
                            "easing": "linear",
                            "step": function () {
                                $this.text(Math.floor(this.count_num).toLocaleString(undefined, {"maximumFractionDigits": 2}).replace(",", "."));
                            },
                            "complete": function () {
                                $this.text(Math.floor(this.count_num).toLocaleString(undefined, {"maximumFractionDigits": 2}).replace(",", "."));
                            }
                        }
                    );

                })(current, current.data("count"));

                queue.splice(i, 1);

            }

        }, 50);

    }

    initialize();

})(jQuery);


//apply vacancy form
(function ($) {
    var popup = $(".popup__outer");
    var maxFileSize = 1024 * 1024 * 2;


    $(".apply_vacancy").each(function (i, form) {
        var self = $(form);
        $('#progress .progress-bar').css(
            'width',
            0 + '%'
        );

        self.find("#agreePrivacy").on("click", function (e) {
            var v = e.target.checked;
            if (v) {
                self.find(".submit_button").removeClass("btn--disabled").removeAttr("disabled")
            } else {
                self.find(".submit_button").addClass("btn--disabled").attr("disabled", "disabled")
            }

        })
        $(form).find(".fileupload_input").fileupload({
            url: "/vacancy/apply",
            method: 'post',
            dataType: 'json',
            autoUpload: false,
            maxFileSize: maxFileSize,
        }).on('fileuploadadd', function (e, data) {
            $.each(data.files, function (i, f) {
                if (f.size > maxFileSize) {
                    self.find(".attachments_info").text("Exceeded the maximum limit, 2Mb are supported").addClass("err_msg")
                    return
                }
                self.find(".attachments_name").val(f.name)
                self.find(".attachments_info").text(f.name).removeClass("err_msg")
                self.data(data)
            })
            self.find(".attachments_name").val()
        }).on("fileuploadprogressall", function (e, data) {
            //popup.find(".row").hide();
            var progress = parseInt(data.loaded / data.total * 100, 10);

            $('#progress .progress-bar').css(
                'width',
                progress + '%'
            );

        }).on("fileuploaddone", function (e, data) {
            popup.find(".row").hide();
            if (data.result.success) {
                popup.find(".completed").show();
            } else {
                var errors = popup.find(".errors")
                errors.show();
                var p = errors.find("p");
                p.text(data.result.msg).css("color", "#DA251C");
            }
        }).on("fileuploadfail", function (e, data) {
            popup.find('.err_msg').text("Attachment upload failed!")
        })
    })


    $(".application__outer form").on("submit", function (e) {


        e.preventDefault();

        var self = $(this);


        if (self.find(".attachments_name").val() === "") {
            self.find(".attachments_info").text("Resume is required").addClass("err_msg")
            return
        }


        if (self.find(".input-field.is-error").length === 0) {

            var agree = self.find("#agreePrivacy")[0].checked;
            if (!agree) {
                alert("Please agree the privacy policy")
                return
            }

            popup.addClass("is-active");

            var data = self.data();

            if (data) {
                popup.find(".uploading").show();

                popup.find(".completed").hide();
                data.submit()
                popup.find(".class_btn").on("click", function () {
                    popup.removeClass("is-active");
                    data.abort();
                })
                popup.find(".success_btn").on("click", function () {
                    popup.removeClass("is-active");
                })
            }

        }

    });

})(jQuery);

(function ($) {
    /*
       var popup = $(".popup__outer");

     $(".download-leaflet__form").on("submit", function (e) {

           e.preventDefault();

           var self = $(this);

           var email = self.find("input[name='email']").val();


           if (self.find(".input-field.is-error").length === 0) {

               $.ajax({
                   url: "/product/leaflet/applydownload",
                   method: 'post',
                   data: self.serialize(),
                   success: function () {

                   }
               })
               popup.addClass("is-active");
               popup.find(".btn").on("click", function () {
                   popup.removeClass("is-active")
               })
               popup.find("p strong").text(email);

           }


       });*/

})(jQuery);


//All the cookie setting stuff
function catapultSetCookie(cookieName, cookieValue, nDays) {
    var today = new Date();
    var expire = new Date();
    if (nDays == null || nDays == 0) nDays = 1;
    expire.setTime(today.getTime() + 3600000 * 24 * nDays);
    document.cookie = cookieName + "=" + escape(cookieValue) + ";expires=" + expire.toGMTString() + "; path=/";
}

function catapultReadCookie(cookieName) {
    var theCookie = " " + document.cookie;
    var ind = theCookie.indexOf(" " + cookieName + "=");
    if (ind == -1) ind = theCookie.indexOf(";" + cookieName + "=");
    if (ind == -1 || cookieName == "") return "";
    var ind1 = theCookie.indexOf(";", ind + 1);
    if (ind1 == -1) ind1 = theCookie.length;
    // Returns true if the versions match
    // console.log(theCookie.substring(ind+cookieName.length+2,ind1))
    // return ctcc_vars.version == unescape(theCookie.substring(ind+cookieName.length+2,ind1));
    return unescape(theCookie.substring(ind + cookieName.length + 2, ind1));
}

function catapultDeleteCookie(cookieName) {
    document.cookie = cookieName + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
}

function catapultAcceptCookies() {
    catapultSetCookie('catAccCookies', "1.0.0", 3650000);
}

(function ($) {
    /* var agreeBtn = $("#cookie_agree");
     var cookie = $(".cookies__outer");
     console.log(cookie)
     if (!catapultReadCookie("catAccCookies")) {
         cookie.removeClass("hide")
     }

     agreeBtn.on("click", function (e) {
         catapultAcceptCookies()
     })
     cookie.find(".btn").on("click", function (e) {

         e.preventDefault();

         cookie.remove();

     });*/


//cookie setting
//new
    var cookieVersion = {
        required: "1.0.0",
        analysis: "1.0.0"
    };
    var CookieSet = {
        required: {
            status: false,
            timestamp: null,
            version: ""
        },
        analysis: {
            status: false,
            version: "",
            timestamp: null,
        }
    };
    var storageKey = "consents";
    (function ($) {
        //showContainer()
        var s = window.localStorage;
        var consents = s.getItem(storageKey);
        if (!consents) {
            showContainer();
            //点击同意全部
            $("#cookie_agree").click(agreeAll);
            $("#cookie_reject").click(rejectAll);
            $("#cookies_save_argeeall").click(agreeAll);
            $("#show_cookie_setting").click(function () {
                showCookieSettings()
            })

        } else {
            CookieSet = JSON.parse(consents);
            enableFunctionsFromCookie()
        }
        $("#cookies_save_settings").click(saveCookieSettings)

    })(jQuery);

    function showContainer() {
        $(".cookies-bottom-container").toggleClass("hide")
    }

    function showAcceptCookies() {
        showContainer();
    }

    function showCookieSettings() {
        $(".cookies_setting").toggleClass("v");
        $(".cookies").toggleClass("hide")
    }


    function agreeAll() {
        for (var key in CookieSet) {
            var item = CookieSet[key];
            item.status = true;
            item.version = cookieVersion[key]
            item.timestamp = (new Date()).getTime();
        }
        SaveCookieToStorage()
    }

    function rejectAll() {
        for (var key in CookieSet) {
            var item = CookieSet[key];
            item.status = false;
            item.version = cookieVersion[key]
            item.timestamp = (new Date()).getTime();
        }
        SaveCookieToStorage()
    }

    function saveCookieSettings() {
        $(".cookies_setting input").each(function (index, field) {
            var name = field.name;
            var value = field.checked;
            for (var k in CookieSet) {
                if (name == k) {
                    var item = CookieSet[k]
                    item.status = value;
                    item.timestamp = (new Date()).getTime();
                    item.version = cookieVersion[name];

                }

            }
            SaveCookieToStorage();

        })
    }


    function SaveCookieToStorage() {
        window.localStorage.setItem(storageKey, JSON.stringify(CookieSet))
        $(".cookies-bottom-container").addClass("hide");
        enableFunctionsFromCookie()
    }


    function enableFunctionsFromCookie() {
        console.log(CookieSet)
        if (CookieSet.analysis && CookieSet.analysis.status === true) {
            console.log("google analysis enable");
            //load google analysis
            var s = document.createElement("script");
            s.src = "https://www.googletagmanager.com/gtag/js?id=UA-43743645-1";
            s.async = true;
            document.body.appendChild(s)
            console.log(s)
            window.dataLayer = window.dataLayer || [];

            function gtag() {
                dataLayer.push(arguments);
            }

            gtag('js', new Date());

            gtag('config', 'UA-43743645-1');
            /*<script async src="https://www.googletagmanager.com/gtag/js?id=UA-43743645-1"></script>
            <script>
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());

                gtag('config', 'UA-43743645-1');
            </script>*/
        } else {
            console.log("google analysis disabled");
        }

    }


})(jQuery);

//360

(function ($) {
    // <script>window.CI360.init();</script>
    window.CI360.init();
    $(".switch-container button").on("click", function (e) {
        console.log("---start---")

        var t = e.currentTarget,
            folder = t.getAttribute("data-src");

        v = window.CI360._viewers[0],
            container = v.container,
            amount = v.amount, //图片张数
            lazyload = false,
            lazySelector = 'lazyload',
            filename = container.getAttribute("data-filename"),
            responsive = false;
        //console.log(v.imageList)
        v.folder = folder;
        src = folder + filename
        // console.log(v)
        // v.images = [];
        var active = v.activeImage - 1;  //0-11
        //  v.activeImage = 1;
        //v.preloadImages(amount, src, lazyload, lazySelector, container, responsive, {});
        /* for (i = 0; i< amount; i++) {
             //第一张图片，设置为当前的角度的地址
             var image = v.images[i];

             if (active < amount) {
                 active++;
             } else {
                 active = 1
             }
             var resultSrc = src.replace('{index}', active);
             image.src=resultSrc;
             console.log(image)
           //  console.log(image.src)
         }*/
        $(t).addClass('active');
        $(t).siblings().removeClass("active")
        v.images = [];
        for (i = 0; i < amount; i++) {
            var image = new Image();
            var resultSrc = src.replace('{index}', i + 1);
            image.src = resultSrc;
            v.images.push(image);

            if (i == active) {
                image.onload = function (e) {
                    v.update();
                }
            }

        }
    })

})(jQuery);

// 新闻订阅2021-05-28

(function ($) {
    var popup = $(".popup__outer");
    console.log(popup, "-----");
    $(".news-letter__form").on("submit", function (e) {

        e.preventDefault();
        var self = $(this);
        var email = self.find("input").val();
        if (email.trim() == "") {
            return
        }
        $.ajax({
            url: "/news/subscribe",
            method: 'post',
            data: self.serialize(),
            success: function (result) {
                console.log("----yes")
                popup.addClass("is-active");
                popup.find("#provided_email").html("aaaa")
                popup.find(".btn").on("click", function () {
                    popup.removeClass("is-active")
                })
                popup.find("p strong").text(email);
            },
            complete: function (result) {

                if (result.status == 500) {
                    var msg = result.responseJSON.msg
                    console.log(msg); //Error 1062: Duplicate entry '154371199@qq.com' for key 'email'
                    popup.addClass("is-active");
                    popup.find("#provided_email").html("aaaa")
                    popup.find(".btn").on("click", function () {
                        popup.removeClass("is-active")
                    })
                    popup.find("p strong").text(email);
                }
            }
        })

    })

})(jQuery);
//显示第三级菜单
(function ($) {


    $(".has_third_menu").on("click", function (e) {

        e.preventDefault();

        var targetId = $(this).data("target-id");
        $("#" + targetId).siblings().removeClass("active")
        $("#" + targetId).toggleClass("active")


    });
    $(".third_left_nav_item").on("click", function (e) {

        e.preventDefault();
        if ($(this).hasClass("active")) {
            return;
        }
        $(this).siblings().removeClass("active");
        $(this).addClass("active")
        var targetId = $(this).find("a").data("target-id")
        $(".right-panel ul").removeClass("active")
        $("#" + targetId).addClass("active");
    })


    //mobile
    $(".mobile-third-menu-container").parent().on("click", function () {

        $(this).find(".mobile-third-menu-container").toggleClass("active");

    })


    //model ranges
    $(".model-range-nav").on("click", function (e) {
        $('.model-range-nav').removeClass("active");
        $(this).addClass("active");
        var targetId = $(this).data("target-id");
        $(".model-range").removeClass("active")
        $("#" + targetId).addClass("active")
    })
})(jQuery);


//alcohol
(function ($) {
   /* var data = [
        {id:"BC12", text:"BYD eBus BC12"},
        {id:"BC15", text:"BYD eBus BC15"},
        {id:"BC18", text:"BYD eBus BC18"},
        {id:"BC70", text:"BYD eBus BC70"},
        {id:"B12", text:"BYD eBus B12"},
        {id:"B13", text:"BYD eBus B13"},
        {id:"B15", text:"BYD eBus B15"},
        {id:"B18", text:"BYD eBus B18"},
    ]*/
    if($("#select_model").length > 0){
        $("#select_model").select2({
            placeholder: "Select a model",
            dropdownParent: $('#alcohol-container'),
           // data: data
        }).on("select2:select", function (e){
            var data = e.params.data;
            if(data) {
                var id = data.id;
                if (id) {
                   var id = id.toLowerCase();
                   if(id == "all"){
                       var items = $(".downloads .item");

                       for(var i = 0; i < items.length;i++){
                           var item = $(items[i])
                           item.show();
                       }
                   } else {
                       var items = $(".downloads .item");

                        for(var i = 0; i < items.length;i++){
                            var item = $(items[i])
                            var key = item.attr("item-key");
                            if(key.toLowerCase() == id){
                                item.show();
                            }else {
                                item.hide();
                            }
                        }

                   }
                }
            }

        });
    }

})(jQuery)